module.exports = __webpack_public_path__ + "static/media/x5_icon.6fbed9e6.svg";